import { with_auth } from "src/adapter";
import adapter from "src/adapter/header";
import { getToken } from "src/utils/storage";

export const listRowNumbers = (currentPage, pageSize, index) => {
  return (currentPage - 1) * pageSize + index + 1;
};

export const getNetDiff = (a, b) => {
  return Math.abs(a - b).toFixed(2);
};

export function toDataURL(url, callback) {
  var xhr = new XMLHttpRequest();

  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.setRequestHeader("Authorization", getToken());
  xhr.responseType = "blob";
  xhr.send();
}

export function cleanObject(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}

export const isEmptyString = (value) => {
  if (!value) {
    return true;
  } else if (value.replace(/\s+/g, "").length === 0) {
    return true;
  } else {
    return false;
  }
};

export const isEmpty = (value) => {
  if (typeof value === "object" || typeof value === "boolean") {
    return false;
  }

  if (typeof value === "number") {
    value = value.toString();
  }

  if (!value) {
    return true;
  } else if (value.replace(/s+/g, "").length === 0) {
    return true;
  } else {
    return false;
  }
};

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const formatFullName = (...parts) =>
  parts
    .map((part) => (part === null || part === undefined ? "" : `${part}`.trim()))
    .filter(Boolean)
    .join(" ");

export async function getFieldValues(field, oldValue, newValue, url) {
  let OldItem = null;
  let NewItem = null;

  const oldItem = await adapter({
    url: `/${url.toLowerCase()}/${oldValue}`,
    method: "GET",
    headers: with_auth(),
  });

  OldItem = oldItem.Data[field];

  const newItem = await adapter({
    url: `/${url.toLowerCase()}/${newValue}`,
    method: "GET",
    headers: with_auth(),
  });

  NewItem = newItem.Data[field];

  return { OldItem, NewItem };
}

export async function readFont(filename) {
  const res = await fetch(filename);

  return res.text();
}

export async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function fixBootstrapModal() {
  var modalNode = document.querySelector('.modal[tabindex="-1"]');
  if (!modalNode) return;

  modalNode.removeAttribute("tabindex");
  modalNode.classList.add("js-swal-fixed");
}

export function restoreBootstrapModal() {
  var modalNode = document.querySelector(".modal.js-swal-fixed");
  if (!modalNode) return;

  modalNode.setAttribute("tabindex", "-1");
  modalNode.classList.remove("js-swal-fixed");
}

export function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}
